import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-equitytype",
  "use": "icon-equitytype-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-equitytype\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13 6H7V12H13V6ZM13 21H7V27H13V21ZM13 36H7V42H13V36ZM21 6H27V12H21V6ZM21 21H27V27H21V21ZM21 36H27V42H21V36ZM35 6H41V12H35V6ZM35 21H41V27H35V21ZM35 36H41V42H35V36Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol